import { render, staticRenderFns } from "./CustomProduct.vue?vue&type=template&id=c81b2bd4"
import script from "./CustomProduct.vue?vue&type=script&lang=js"
export * from "./CustomProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports